import React, { useState } from 'react'
import { Breadcrumb, Col, Form, Row } from 'react-bootstrap'
import Card from '../../../UI/Card/Card'
import ConfirmationModal from '../../../UI/ConfirmationModal/ConfirmationModal'
import Graybg from '../../../UI/Graybg'
import Input from '../../../UI/Input/Input'
import Modals from '../../../UI/Modals/Modals'
import SecBTN from '../../../UI/SecBTN'
import Select from '../../../UI/Select/Select'
import SuccessModal from '../../../UI/SuccessModal/SuccessModal'
import classes from './VerifyQuestion.module.css'

const VerifyQuestion = () => {
  const [showPopUp1,setShowPopUp1] = useState(false)
  const [showPopUp2,setShowPopUp2] = useState(false)
  const [showPopUp3,setShowPopUp3] = useState(false)
  const [showPopUp4,setShowPopUp4] = useState(false)
  const onVerify = () => {
    setShowPopUp1(true);
  }
  const yesHandler = () => {
    setShowPopUp1(false);
    setShowPopUp2(true);
  }
  const onHideHandler = () => {
    setShowPopUp1(false);
    setShowPopUp2(false);
    setShowPopUp3(false);
    setShowPopUp4(false);
  }
  const reviewHandler = () => {
    setShowPopUp3(true)
  }
  const onConfirm = () => {
    setShowPopUp3(false);
    setShowPopUp4(true);
  }
  return (
    <div className="section">
      <ConfirmationModal
        title="Are you sure you want to Verify?"
        show={showPopUp1}
        onHide={onHideHandler}
        yesHandler={yesHandler}
        confirmTxt="Yes"
      />
      <SuccessModal
        show={showPopUp2}
        onHide={onHideHandler}
        title="Verified Successfully!"
        btnTxt="Ok"
      />
      <Modals
        className={classes.modal}
        show={showPopUp3}
        onHide={onHideHandler}
      >
        <h5>Choose the reason?</h5>
        <p className="mb-3">You can choose more than one.</p>
        <div className={classes.reason}>
          <Form.Check
            type="checkbox"
            label={`Wrong Question/Incomplete Solution`}
          />
        </div>
        <div className={classes.reason}>
          <Form.Check
            type="checkbox"
            label={`Wrong Question/Incomplete Solution`}
          />
        </div>
        <div className={classes.reason}>
          <Form.Check
            type="checkbox"
            label={`Wrong Question/Incomplete Solution`}
          />
        </div>
        <div className={classes.reason}>
          <Form.Check
            type="checkbox"
            label={`Wrong Question/Incomplete Solution`}
          />
        </div>
        <div className={classes.reason}>
          <Form.Check
            type="checkbox"
            label={`Wrong Question/Incomplete Solution`}
          />
        </div>
        <div className={classes.reason}>
          <Form.Check
            type="checkbox"
            label={`Wrong Question/Incomplete Solution`}
          />
        </div>
        <div className="mt-3 text-center">
          <SecBTN className="sec-btn1" onClick={onConfirm}>
            Confirm
          </SecBTN>
        </div>
      </Modals>
      <SuccessModal
        show={showPopUp4}
        onHide={onHideHandler}
        title="Sent for Review Successfully!"
        btnTxt="Ok"
      />
      <h4>Verify Question</h4>
      <Breadcrumb>
        <Breadcrumb.Item>Question</Breadcrumb.Item>
        <Breadcrumb.Item active>Verify Question</Breadcrumb.Item>
      </Breadcrumb>
      <Graybg>
        <Card>
          <Row>
            <Col md={8} sm={12} className="mb-2">
              <Select>
                <option selected disabled>
                  Select Subject
                </option>
              </Select>
            </Col>
            <Col md={4} sm={12} className="mb-2">
              <Input placeholder="QiD :" />
            </Col>
            <Col md={12} className="mb-2">
              <Select>
                <option selected disabled>
                  Select Topic
                </option>
              </Select>
            </Col>
            <Col md={12} className="mb-2">
              <Select>
                <option selected disabled>
                  Select Sub-topic
                </option>
              </Select>
            </Col>
            <Col md={12} className="mb-2">
              <Select>
                <option selected disabled>
                  Select Toughness
                </option>
              </Select>
            </Col>
            <Col md={12}>
              <Select>
                <option selected disabled>
                  Select Question type
                </option>
              </Select>
            </Col>
          </Row>
        </Card>
      </Graybg>
      <div className={classes["question"]}>
        <div className={classes.card}>
          <h6>Question :</h6>
        </div>
        <h6 className="my-2">Answer : C</h6>
        <div className={classes.card}>
          <h6>Solution :</h6>
        </div>
      </div>
      <div className="d-flex justify-content-between">
        <SecBTN className="sec-btn" onClick={reviewHandler}>
          Needs Review
        </SecBTN>
        <SecBTN className="sec-btn1" onClick={onVerify}>
          Verified
        </SecBTN>
      </div>
    </div>
  );
}

export default VerifyQuestion
